import React from 'react';

type IUseFocusHook = (urlHash: string | undefined) => boolean;

export const useFocus: IUseFocusHook = urlHash => {
  const [focus, setFocus] = React.useState<boolean>(false);

  const hasIdhInUrl = (id: string) => {
    const url = window.location.href;
    return RegExp(`#${id}`).test(url);
  };

  React.useEffect(() => {
    if (!urlHash) return;

    const timerForGetUrl = setTimeout(() => setFocus(hasIdhInUrl(urlHash)), 300);
    return () => clearTimeout(timerForGetUrl);
  }, []);

  return focus;
};
